export default "__VITE_ASSET__B$XzqkSV__"